import { render, staticRenderFns } from "./defaultSetting.vue?vue&type=template&id=c5617542&scoped=true&lang=pug"
import script from "./defaultSetting.vue?vue&type=script&lang=js"
export * from "./defaultSetting.vue?vue&type=script&lang=js"
import style0 from "./defaultSetting.vue?vue&type=style&index=0&id=c5617542&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5617542",
  null
  
)

export default component.exports